import { TransactionStatus, TransactionStatusType } from "@/api"

export const isTxPending = (status: TransactionStatus): boolean => {
  return (
    status.type !== TransactionStatusType.Completed &&
    status.type !== TransactionStatusType.Rejected &&
    status.type !== TransactionStatusType.PermitNotSigned
  )
}
